import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

import Residencial07 from "../../static/Projetos/Residencial07.webp";
import Residencial0 from "../../static/Projetos/Rectangle13.webp";
import Residencial01 from "../../static/Projetos/Residencial01.webp";
import Comercial from "../../static/Projetos/Comercial.webp";
import Comercial01 from "../../static/Projetos/Comercial01.webp";
import Comercial02 from "../../static/Projetos/Comercial02.webp";

const images = [
  { src: Residencial07, alt: "Cliente comercial, Usina de operação, Economia anual R$705.347,52", route: "/Projetos" },
  { src: Residencial0, alt: "Cliente residencial, Usina de operação, Economia anual R$ 36.696", route: "/Projetos" },
  { src: Residencial01, alt: "Cliente residencial, Usina de operação, Economia anual R$ 12.374,00", route: "/Projetos" },
  { src: Comercial, alt: "Cliente Comercial, Usina de operação, Economia anual R$ 10.800,00", route: "/Projetos" },
  { src: Comercial01, alt: "Cliente Comercial, Usina de operação, Economia anual R$ 150.216,00", route: "/Projetos" },
  { src: Comercial02, alt: "Cliente Comercial, Usina de operação, Economia anual R$ 197.676,00", route: "/Projetos" },
];

const CarouselProjetosClientes = React.memo(() => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [visibleImagesCount, setVisibleImagesCount] = useState(2);
  const [startIndex, setStartIndex] = useState(0);
  const [touchStartX, setTouchStartX] = useState(null);
  const cardsContainer = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const updateResponsiveness = useCallback(() => {
    const isMobile = window.innerWidth < 768;
    setIsMobile(isMobile);
    setVisibleImagesCount(isMobile ? 1 : window.innerWidth < 1162 ? 2 : 2);
  }, []);

  useEffect(() => {
    updateResponsiveness();
    window.addEventListener("resize", updateResponsiveness);

    return () => {
      window.removeEventListener("resize", updateResponsiveness);
    };
  }, [updateResponsiveness]);

  const prevSlide = useCallback(() => {
    setStartIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  }, []);

  const nextSlide = useCallback(() => {
    setStartIndex((prevIndex) =>
      Math.min(prevIndex + 1, images.length - visibleImagesCount)
    );
  }, [visibleImagesCount]);

  const handleTouchStart = useCallback((event) => {
    setTouchStartX(event.touches[0].clientX);
  }, []);

  const handleTouchEnd = useCallback((event) => {
    if (touchStartX === null || !cardsContainer.current) return;

    const touchEndX = event.changedTouches[0].clientX;
    const touchDiff = touchStartX - touchEndX;

    if (touchDiff > 50) {
      nextSlide();
    } else if (touchDiff < -50) {
      prevSlide();
    }

    setTouchStartX(null);
  }, [touchStartX, nextSlide, prevSlide]);

  return (
    <div className="relative">
      <div
        className="cor-da-marca flex flex-col fontfamily text-white"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <div className="flex items-center justify-between">
          {!isMobile && (
            <button
              className="text-white text-2xl hide-on-mobile"
              onClick={prevSlide}
              disabled={startIndex === 0}
              aria-label="Slide anterior"
            >
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
          )}
          <div
            ref={cardsContainer}
            className="flex justify-around w-full lg:mx-2 overflow-hidden"
          >
            {images.slice(startIndex, startIndex + visibleImagesCount).map((image, index) => (
              <div
                key={startIndex + index}
                className={`h-96 lg:w-3/5 w-full tamanhoCard flex flex-col justify-center lg:p-4 p-2 mb-4 ${
                  index >= visibleImagesCount ? "hidden" : ""
                } card-transition ${
                  hoveredIndex === startIndex + index
                    ? "transition-up"
                    : "transition-down"
                }`}
                onMouseEnter={() => setHoveredIndex(startIndex + index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div
                  className={`transition-all duration-500 ${
                    hoveredIndex === startIndex + index ? "h-1/6" : "h-96"
                  }`}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="h-full w-full rounded-3xl object-cover"
                    loading="lazy"
                    width={300}  // Ajuste com base no tamanho real da imagem
                    height={200} // Ajuste com base no tamanho real da imagem
                  />
                </div>
                <div
                  className={`transition-all duration-500 cor-da-marca-02 rounded-3xl ${
                    hoveredIndex === startIndex + index
                      ? "lg:h-80 h-5/6"
                      : "lg:h-0 h-1/6"
                  } mt-2`}
                >
                  <div className="text-sm cor-da-marca-02 rounded-3xl flex justify-around items-center flex-wrap p-2 lg:pt-2 lg:pb-2">
                    <div className="pl-4">
                      <h2 className="text-lg font-bold">{image.alt.split(',')[0]}</h2>
                      <p
                        className={`text-zinc-300 transition-opacity text-sm duration-500 ${
                          hoveredIndex === startIndex + index
                            ? "opacity-0"
                            : "opacity-100"
                        }`}
                      >
                        {image.alt.split(',')[1].slice(0, 40)}...
                      </p>
                    </div>
                    <div className="pr-4">
                      <h3 className="text-md font-semibold">{image.alt.split(',')[2]}</h3>
                      <p className="text-green-500">{image.alt.split(',')[3]}</p>
                    </div>
                    <div className="pr-3">
                      <Link to={image.route}>
                        <button className="cor-da-letra bg-white rounded-3xl m-1 p-2 pr-4 pl-4 font-bold">
                          VER MAIS
                        </button>
                      </Link>
                    </div>
                  </div>
                  <div className="p-3">
                    <div
                      className={`transition-opacity text-sm duration-500 ${
                        hoveredIndex === startIndex + index
                          ? "opacity-100"
                          : "opacity-0"
                      }`}
                    >
                      {image.alt.split(',').slice(1).map((text, i) => (
                        <p key={i}>{text}</p>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {!isMobile && (
            <button
              className="text-white text-2xl hide-on-mobile"
              onClick={nextSlide}
              disabled={startIndex + visibleImagesCount >= images.length}
              aria-label="Próximo slide"
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          )}
        </div>
        <div className="flex justify-center mt-10">
          {images.map((_, index) => (
            <span
              key={index}
              className={`indicator w-3 h-3 mx-1 rounded-full cursor-pointer ${
                startIndex <= index && index < startIndex + visibleImagesCount
                  ? "cor-da-marca-03"
                  : "bg-white"
              }`}
              onClick={() => setStartIndex(index)}
              aria-label={`Ir para slide ${index + 1}`}
            ></span>
          ))}
        </div>
      </div>
    </div>
  );
});

export default CarouselProjetosClientes;
